import './Popup.css';

// Import assets
import correctIcon from './svg/Correct_GreenBubble.svg';
import incorrectIcon from './svg/Error_RedBubble.svg';

// Vendors
import React from 'react';
import {CSSTransition} from 'react-transition-group';

export default function Popup(props) {
  const successMessage = `Nice one!`;
  const errorMessage = `Sorry!\nTry Again`;

  let timeout;

  return (
    <CSSTransition
      in={props.showPopup}
      timeout={350}
      classNames="fade"
      unmountOnExit
      onEntered={() => {
        timeout = setTimeout(() => {
          props.callback();
        }, 500);
      }}
      onExited={() => {
        clearTimeout(timeout);
        timeout = undefined;

        // Pass true if this is a callback after exit
        props.callback(true);
      }}
    >
      <div className="Popup">
        <div>
          <img src={props.isCorrect ? correctIcon : incorrectIcon} alt={props.isCorrect ? 'A check icon' : 'A cross icon'}/>
          <p>{props.isCorrect ? successMessage : errorMessage}</p>
        </div>
      </div>
    </CSSTransition>
  )
}



// WEBPACK FOOTER //
// ./src/components/rlgl/Popup/Popup.js